import styled from 'styled-components';

export const CompressorDetailsTabContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .body {
    padding: 0 ${({ theme: { token } }) => token.padding}px;
    height: 100%;
  }

  .footer {
    align-self: flex-end;
    padding-right: ${({ theme: { token } }) => token.padding}px;
    padding-bottom: ${({ theme: { token } }) => token.padding}px;
  }

  .divider {
    margin: ${({ theme: { token } }) => token.margin}px 0;
  }
`;
